var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneRotaryRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.4 192.3A64 64 0 0 0 314.9 160H197.1a64 64 0 0 0 -55.6 32.3L36.2 376.6A32 32 0 0 0 32 392.5V448a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-55.5a32 32 0 0 0 -4.2-15.9zM432 432H80v-35.3l103.3-180.7a16 16 0 0 1 13.9-8.1h117.7a16 16 0 0 1 13.9 8.1L432 396.8zM256 256a64 64 0 1 0 64 64 64 64 0 0 0 -64-64zm250.2-133C436.8 65 347.4 32 256 32S75.2 65 5.8 123A16.5 16.5 0 0 0 0 135.6V192a16 16 0 0 0 16 16h70.1a16 16 0 0 0 14.3-8.9L128 128c39.9-17.3 83.2-24 128-24 44.8 0 88.1 6.7 128 24l27.6 71.2a16 16 0 0 0 14.3 8.9H496a16 16 0 0 0 16-16v-56.4a16.5 16.5 0 0 0 -5.8-12.6z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRotaryRegular);
export default __webpack_public_path__ + "static/media/phone-rotary-regular.3ead5cd9ba007cd318cfa9c2976b06c8.svg";
export { ForwardRef as ReactComponent };